import { createFileRoute } from "@tanstack/react-router"

import { Module } from "~/components/design-system/pages"
import { MarketStrategyPage } from "~/components/market-strategy/MarketStrategyPage"
import { ScopeDraftProvider } from "~/components/market-strategy/scopeDraftContext"
import { useChannelScope } from "~/components/market-strategy/useChannelScope"
import { useScopeDraft } from "~/components/market-strategy/useScopeDraft"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import GenericError from "~/components/reusable/errors/GenericError"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import NotFound from "~/components/reusable/NotFound"
import { NoAccessError } from "~/constants/errors"
import { useCompany } from "~/hooks/useCompany"
import { usePageTracking } from "~/hooks/usePageTracking"
import useShowHelix from "~/hooks/useShowHelix"
import { adminRouteGuard } from "~/utils/routeGuards"

export const Route = createFileRoute("/_auth/market-strategy/")({
  staticData: { skipSkuStoreData: true },
  beforeLoad: adminRouteGuard,
  component: RouteComponent,
  errorComponent: ({ error }) =>
    error instanceof NoAccessError ? <NotFound /> : <GenericError error={error} />,
})

// Same gate as /demand: Planning scope is a Demand concept, so the module ships with Helix.
// The flag controls reachability only; each control still carries its own `requires`.
function RouteComponent() {
  usePageTracking("Market Strategy")
  const showHelix = useShowHelix()
  const { isLoading } = useCompany()
  const { rows } = useChannelScope()
  const draft = useScopeDraft(rows)

  if (!showHelix) return <NotFound />
  if (isLoading) return <LoadingOverlay />

  // Above <Module>: the inspector is registered into context and rendered by Module itself, so a
  // provider inside the page would not reach it.
  return (
    <ScopeDraftProvider value={draft}>
      <Module breadcrumb={<BreadcrumbWrapper />}>
        <MarketStrategyPage />
      </Module>
    </ScopeDraftProvider>
  )
}
